const CustomList = ({title,points,pointStyle}) => {
    //  const {title,points,pointStyle} = props
    return<>
    <style>{`
        .custom-list {
          list-style: none;
          padding-left: 20px;
        }
        .custom-list li::marker {
          content: "${pointStyle} ";
          font-size: 1.2rem;
        }
      `}</style>
            <div>
                
                  <p>
                    {title}
                  </p>
                  <ul className='custom-list' style={{paddingLeft:"50px"}}>
                    {points?.map((point)=>{
                      return <li>{point}</li>
                    })}
                  </ul>
            </div>

</>
}

export default CustomList;